module.exports = __webpack_public_path__ + "static/media/teampay.e602ae30.png";